<template>
  <div class="pageTops">
    <!-- <div class="pageTitle hidden-xs-only">
      <div class="pageTitles width">
        <div class="left">Hi，欢迎来到安徽百先科技有限公司</div>
        <div class="right">热线服务：<span>40083 66685</span></div>
      </div>
    </div> -->
    <div class="pageTop width">
      <div class="left">
        <img src="@/assets/images/logo.jpg" alt="" />
        <span>百先科技</span>
      </div>
      <div class="right">
        <div class="menu hidden-xs-only">
          <ul>
            <li class="menuItem" @click="linkFn(item)" @mouseenter='enterFn(item)' @mouseleave='leaveFn(item)' v-for="(item, index) in items" :key='index'>
              <router-link class="menuList" :to='item.children[0].link' style="display: block; height: 65px; line-height: 65px;">{{ item.text }}</router-link>
              <!-- <div class="menus" v-if="menuDetailList.length > 1">
                <div ref="menuDetail" class="menuDetail width hidden-xs-only">
                  <span>{{ title }}</span>
                  <div class="right">
                    <router-link :to='item.link' v-for="(item,index) in menuDetailList" :key='index'>{{ item.text }}</router-link>
                  </div>
                </div>
              </div> -->
            </li>
            <div class="tel">服务热线：<span>40083 66685</span></div>
          </ul>
        </div>
          <!-- <div class="btn hidden-sm-and-up">
            <span class="title">{{title}}</span>
            <i v-if="!show" class="iconfont icon-caidan" @click="openFn"></i>
            <i v-else class="iconfont icon-guanbi" @click="openFn"></i>
            <van-tree-select v-if="show" @click-nav='clickNav' @click-item='clickItem' :items="items" :active-id.sync="activeId" :main-active-index.sync="activeIndex" />
          </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// import { TreeSelect } from 'vant';
export default {
  name:"pageTop",
  // components:{
  //     [TreeSelect.name]:TreeSelect
  // },
  data(){
    return {
      title:'',
      menuDetailList:[],
      items:[
        {text:'首页',children:[
          {text:'首页',id:1,link:'/',},
        ]},
        {text:'关于我们',children:[
            {text:'公司简介',id:2,link:'/about',},
            {text:'服务范围',id:3,link:'/about/service',},
            {text:'选择我们',id:4,link:'/about/choose',},
            {text:'业务话术',id:5,link:'/about/article',},
            {text:'增值服务',id:6,link:'/about/moreService',},
            {text:'服务保障',id:7,link:'/about/security',},
            {text:'联系我们',id:8,link:'/about/contact',},
        ]},
        // {text:'新闻中心',children:[
        //     {text:'公司新闻',id:10,link:'/news',},
        //     {text:'行业动态',id:11,link:'/news/newsHy',},
        // ]},
        {text:'服务项目',children:[
            {text:'服务范围',id:12,link:'/service',},
        ]},
        // {text:'增值服务',children:[
        //     {text:'增值服务',id:13,link:'/about/moreService',},
        // ]},
        {text:'成功案例',children:[
            {text:'成功案例',id:14,link:'/cases',},
        ]},
        {text:'软件下载',children:[
            {text:'软件下载',id:15,link:'/software',},
        ]},
        // {text:'服务保障',children:[
        //     {text:'服务保障',id:15,link:'/about/security',},
        // ]},
        // {text:'联系我们',children:[
        //     {text:'联系我们',id:16,link:'/about/contact',},
        // ]}
      ],
      show:false,
      activeId: 0,
      activeIndex: 0,
    }
  },
  computed:{
    onRoutes() {
      return this.$route.path;
    },
  },
  created(){
    // this.items.forEach(item=>{
    //     item.children.forEach(item1=>{
    //         if(item1.link==this.$route.path){
    //             this.title=item1.text
    //         }
    //     })
    // })
    // if(this.$route.path=='/cases/casesDetail'){
    //     this.title='成功案例'
    //     this.activeId=14
    //     this.activeIndex=5
    // }
    // if(this.$route.path=='/news/newsDetail'){
    //     this.title='新闻中心'
    //     this.activeId=0
    //     this.activeIndex=2
    // }
  },
  methods:{
      enterFn(value){
        this.show=true
        this.title=value.text
        this.items.forEach(item=>{
          if(item.text==value.text){
            this.menuDetailList=item.children
          }
        })
      },
      leaveFn(value){
        this.show=false
        this.menuDetailList=[]
      },
      linkFn(value){
        this.$store.commit('pageTitle',value.children[0].text)
      },
      handleOpen(index, indexPath) {
        this.closeIndex=index
        this.$router.push(index);
      },
      openFn(){
        this.show=!this.show
        this.items.forEach((item,index)=>{
          item.children.forEach(items=>{
            if(this.$route.path==items.link){
              this.activeIndex=index
              this.activeId=items.id
            }
          })
        })
      },
      clickNav(index){
        this.activeId=0
      },
      clickItem(index){
        this.$router.push(index.link)
        this.show=false
        this.title=index.text
        this.$store.commit('pageTitle',index.text)
      }
  }
}
</script>
<style scoped>
.pageTops {
  background: #fff;
  box-shadow: 0px 5px 10px #f7f7f7;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}

.pageTops .pageTitle {
  background: #f7f7f7;
}

.pageTops .pageTitle .pageTitles {
  height: 40px;
  margin: 0 auto;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pageTops .pageTitle .pageTitles .left, .pageTops .pageTitle .pageTitles .right {
  font-size: 12px;
}

.pageTops .pageTitle .pageTitles span {
  color: #2e76cb;
  font-size: 18px;
  font-weight: 700;
}

.pageTops .pageTop {
  height: 70px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.pageTops .pageTop .left {
  display: flex;
  align-items: center;
}

.pageTops .pageTop .left img {
  width: 60px;
  margin-left: -10px;
  display: block;
}

.pageTops .pageTop .left span {
  font-size: 28px;
}

.pageTops .pageTop .right {
  height: 100%;
}

.pageTops .pageTop .right .menu {
  height: 100%;
}

.pageTops .pageTop .right .menu ul {
  height: 100%;
  display: flex;
  align-items: center;
}

.pageTops .pageTop .right .menu ul li {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
  margin: 0 0 0 20px;
  cursor: pointer;
  padding: 0 10px;
}

.pageTops .pageTop .right .menu ul li:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 70px;
  background: url('~@/assets/images/nav_bg.jpeg') no-repeat;
  background-size: 100% 100%;
  transition: .5s;
}

.pageTops .pageTop .right .menu ul li:hover:after {
  bottom: 0px;
}

.pageTops .pageTop .right .menu ul li .menuList {
  z-index: 1;
  font-size: 16px;
  color: #333333;
}

.pageTops .pageTop .right .menu ul li:hover .menuList {
  color: white;
  transition: .5s;
}

.pageTops .pageTop .right .menu ul li:hover .menus {
  display: block;
  animation: show .5s;
}

.tel {
  margin-left: 80px;
  font-size: 18px;
  font-weight: 700;
  color: #333333;
}

.tel span {
  color: #2e76cb;
  font-size: 20px !important;
  font-weight: 700;
  margin: 0 !important;
  padding: 0 !important;
}

.pageTops .pageTop .right .icon {
  font-size: 20px;
}

.pageTops .pageTop .right span {
  margin: 0 15px;
  padding: 20px 0;
  font-size: 14px;
  cursor: pointer;
}

.pageTops .pageTop .right .btn {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
}

.pageTops .pageTop .right .btn .van-tree-select {
  flex-direction: row-reverse;
  position: absolute;
  right: -39px;
  width: 100vw;
  top: 50px;
}

.pageTops .pageTop .right .btn .van-tree-select__item {
  padding: 0 25px 0 40px;
}

.pageTops .pageTop .tabClass {
  border-bottom: 5px solid #2e76cb;
}

.pageTops .pageTop .tabClass {
  color: #2e76cb !important;
}

.pageTops .menus {
  display: none;
  position: fixed;
  width: 100%;
  top: 90px;
  left: 0;
  background: white;
}

.pageTops .menus .menuDetail {
  display: flex !important;
  align-items: center;
  background: white;
  margin: auto;
  box-shadow: 0 5px 5px #dedede;
  margin-top: 10px;
}

.pageTops .menus .menuDetail span {
  background: linear-gradient(to right, #3197f0, #6bc22b);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  -ms-background-clip: text;
  -o-background-clip: text;
  color: transparent;
  display: inline-block;
  font-size: 20px;
  margin: 0 50px;
}

.pageTops .menus .menuDetail .right a {
  margin: 0 20px;
  font-size: 14px;
  color: #000;
}

.width {
  width: 1200px;  
}

@keyframes show{
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/header-meun/index.vue